import * as React from "react";
import { Icon, Table } from "semantic-ui-react";
import StatusDisplay from "./StudyStatusIcon";
import styles from "./StudyTable.css";
import PropTypes from "prop-types";
import { connect } from "react-redux";

const StudyTable = ({ studiesToShow, onAdd, dictionary }) => {
	return (
		<>
			<Table celled>
				<caption>Study</caption>
				<Table.Header>
					<Table.Row>
						<Table.HeaderCell>{dictionary?.study || "Study"}</Table.HeaderCell>
						<Table.HeaderCell>{dictionary?.title || "Title"}</Table.HeaderCell>
						<Table.HeaderCell>{dictionary?.expireDate || "Exp. Date"} </Table.HeaderCell>
						<Table.HeaderCell>{dictionary?.primaryInvestigator || "PI"}</Table.HeaderCell>
						<Table.HeaderCell>{dictionary?.status || "Status"}</Table.HeaderCell>
						<Table.HeaderCell>&nbsp;</Table.HeaderCell>
					</Table.Row>
				</Table.Header>
				<Table.Body>{studiesToShow.map((study, index) => {
					return (
						<Table.Row key={`study-${index}`}>
							<Table.Cell><a href={"#"}>{study.number}</a></Table.Cell>
							<Table.Cell>{study.title}</Table.Cell>
							<Table.Cell>{study.expireDate}</Table.Cell>
							<Table.Cell>{study.primaryInvestigator}</Table.Cell>
							<Table.Cell>
								<StatusDisplay status={study.status}/>
							</Table.Cell>
							<Table.Cell className={styles.addButton}>
								<a onClick={() => onAdd(study)}><Icon name="add"/></a>
							</Table.Cell>
						</Table.Row>
					);
				})}
				</Table.Body>
			</Table>
		</>
	);
};

StudyTable.propTypes = {
	studiesToShow: PropTypes.array,
	onAdd: PropTypes.func
};

const mapStateToProps = state => ({
	dictionary: state.dictionary.irbStudy
});

export default connect(mapStateToProps)(StudyTable);